<template>
  <div>
    <section class="hero is-success is-fullheight">
      <div class="hero-body">
        <div class="container has-text-centered">
          <div class="column is-4 is-offset-4">
            <h3 class="title has-text-grey">
              解体相談所システム<br>ログイン画面
              <!-- 営業リスト管理システム<br>ログイン画面-- -->
            </h3>
            <div class="box">
              <form>
                <p class="has-text-danger">
                  {{ message }}
                </p>
                <div class="field">
                  <b-field>
                    <b-input v-model="id" placeholder="ID" size="is-large" @keyup.native.enter="login" />
                  </b-field>
                </div>
                <div class="field">
                  <div class="control">
                    <b-field>
                      <b-input v-model="password" type="password" size="is-large" placeholder="Password"
                               password-reveal @keyup.native.enter="login"
                      />
                    </b-field>
                  </div>
                </div>
                <button type="button" class="button is-block is-info is-large is-fullwidth" @click="login">
                  ログイン
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data() {
    return {
      id: '',
      password: '',
      message: '',
    }
  },
  created() {
    if (Number(localStorage.loggedIn)) {
      this.$router.push({name: 'Home'})
    }
  },
  methods: {
    login() {
      if (this.id === '' || this.password === '') {
        return
      }
      this.openLoading()
      this.$http.post('/login', {
        id: this.id,
        password: this.password,
      }).then(response => {
        this.closeLoading()
        this.$buefy.toast.open('ログイン成功')
        // this.$buefy.toast.open(`ログイン成功`)
        localStorage.loggedIn = 1
        localStorage.employeeName = response.data.employee_name
        if (this.$route.query.redirect) {
          this.$router.push(this.$route.query.redirect)
        } else {
          this.$router.push({name: 'Home'})
        }
      }).catch(error => {
        localStorage.loggedIn = 0
        localStorage.employeeName = null
        this.closeLoading()
        this.$buefy.toast.open(`ログイン失敗`)
        console.log(error)
      })
    },
  },
}
</script>

<style scoped>
html, body {
  font-family: 'Open Sans', serif;
  font-size: 14px;
  font-weight: 300;
}

.hero.is-success {
  background: #F2F6FA;
}

.box {
  margin-top: 5rem;
}

.avatar img {
  padding: 5px;
  background: #fff;
  border-radius: 50%;
  -webkit-box-shadow: 0 2px 3px rgba(10, 10, 10, .1), 0 0 0 1px rgba(10, 10, 10, .1);
  box-shadow: 0 2px 3px rgba(10, 10, 10, .1), 0 0 0 1px rgba(10, 10, 10, .1);
}

input {
  font-weight: 300;
}

p {
  font-weight: 700;
  padding-bottom: 1rem;
}
</style>
